export default __webpack_public_path__ + "static/media/messageReceived_notification.b66d2fee.mp3";